import { ImmutableMap } from "@suse-o11y/immutable-map";
import { Signal } from "@suse-o11y/signal";
import { usePermanent } from "@suse-o11y/use-permanent";
import React from "react";

import { QueryScopeContextProvider } from "./context";

/**
 * The boundary component keeping track of all queries used inside of it.
 * Does not track queries used in nested boundaries, unless they are also registered in this boundary.
 */
const QueryScopeBoundary: React.FC<{
	children: React.ReactNode;
}> = ({ children }) => {
	const value = usePermanent(() => Signal(ImmutableMap.empty<string, Signal<number>>()));

	return <QueryScopeContextProvider value={value}>{children}</QueryScopeContextProvider>;
};

export { QueryScopeBoundary };
